import { SweetpassCheckoutConfirmingPayment } from './ConfirmingPayment';
import { SweetpassCheckoutContainer } from './Container';
import { SweetpassHowItWorks } from './HowItWorks';
import { SweetpassInfoContainer } from './InfoContainer';
import { SweetpassCheckoutLoadingPlaceholder } from './LoadingPlaceholder';
import { SweetpassPaymentMethod } from './PaymentMethod';
import { SweetpassPaymentProvider } from './PaymentProvider';
import { SweetpassPurchaseCta } from './PurchaseCta';
import { SweetpassCheckoutTitle } from './Title';
import { SweetpassCheckoutTotal } from './Total';
import { SweetpassTwoColumnsLayout } from './TwoColumnsLayout';

export const Checkout = {
  Container: SweetpassCheckoutContainer,
  LoadingPlaceholder: SweetpassCheckoutLoadingPlaceholder,
  ConfirmingPayment: SweetpassCheckoutConfirmingPayment,
  TwoColumnsLayout: SweetpassTwoColumnsLayout,
  InfoContainer: SweetpassInfoContainer,
  Title: SweetpassCheckoutTitle,
  HowItWorks: SweetpassHowItWorks,
  PaymentProvider: SweetpassPaymentProvider,
  PaymentMethod: SweetpassPaymentMethod,
  Total: SweetpassCheckoutTotal,
  PurchaseCta: SweetpassPurchaseCta,
};
